import {
  isAdminEmailValid,
  isClientIdValid,
  isSecretKeyValid,
  isUuidValid
} from '../CredentialsFields/helpers';

export interface CredentialsFormValues {
  parentUuid: string;
  uuidConfirmed: boolean;
  clientId: string;
  secretKey: string;
  adminEmail: string;
}

export type CredentialsField = Exclude<
  keyof CredentialsFormValues,
  'uuidConfirmed'
>;

export const isCredentialsValid = (v: CredentialsFormValues): boolean =>
  isUuidValid(v.parentUuid) &&
  v.uuidConfirmed &&
  isClientIdValid(v.clientId) &&
  isSecretKeyValid(v.secretKey) &&
  isAdminEmailValid(v.adminEmail);

export const trimCredentials = (
  v: CredentialsFormValues
): CredentialsFormValues => ({
  parentUuid: v.parentUuid.trim(),
  uuidConfirmed: v.uuidConfirmed,
  clientId: v.clientId.trim(),
  secretKey: v.secretKey.trim(),
  adminEmail: v.adminEmail.trim()
});
